<mat-card
  appearance="outlined"
  class="capsule-conseil {{ appearance }}"
  [appDynamicBackgroundImage]="getBackgroundImageSource()"
>
  <mat-card-content>
    <h2 *ngIf="titre" class="capsule-conseil-titre dsd-t-3">
      <span>{{ titre }} </span>
      <app-tooltip *ngIf="hasInfobulle" [titre]="titreInfobulle" [texte]="this.contenuInfobulle"></app-tooltip>
    </h2>
    <h2 *ngIf="!titre" class="capsule-conseil-titre">{{ 'general.bon-a-savoir' | translate }}</h2>

    <p [ngClass]="{ 'truncate-text': !isFullText && isLinesGreaterThan4 }">
      <ng-content select="div.capsule-content"></ng-content>
    </p>
    <span *ngIf="isLinesGreaterThan4" class="mobile-only link green" (click)="showFullText()"
      >{{ 'general.en-savoir-' + (isFullText ? 'moins' : 'plus') | translate }}
    </span>
  </mat-card-content>
</mat-card>
